import React, { useState } from "react";
import notification from "../../assets/images/microsite/results.png";
import "../../layoutMicrositio/notifications/styleFormMicrosito.css";
import parcial2 from "../../assets/images/microsite/times.png"


export const FormNotificationMicrosite = ({
    notifications,
    loading,
    markAsRead,

    //? REFRESH
    refreshing,
    newNotifications,

    //? PREVIEW AND DONWLOAD
    previewWorkOrderPDF, printWorkOrder,
    loadingDownloadPdf
    


}) => {

    const [expanded, setExpanded] = useState({});
    const [removing, setRemoving] = useState({});
    const completeNotifications = notifications.filter(x => x.is_complete);
    const partialNotifications = notifications.filter(x => !x.is_complete);

    const [showAllComplete, setShowAllComplete] = useState(false);
    const [showAllPartial, setShowAllPartial] = useState(false);

    const [loadingPreview, setLoadingPreview] = useState(null);

    if (loading) {
        return (
            <div className="notification-loading">
                <div className="notification-loading-spinner">
                    <i className="fa fa-spinner fa-spin fa-2x" />
                </div>

                <div className="notification-loading-title">
                    Actualizando notificaciones
                </div>

                <div className="notification-loading-subtitle">
                    Espera un momento...
                </div>
            </div>
        );
    }

    if (!notifications.length) {
        return (
            <p className="text-center notification-cero">
                No hay notificaciones
            </p>
        );
    }

    const handlePreview = async (idWorkOrder, nim) => {
        try {
            setLoadingPreview(idWorkOrder);
            await previewWorkOrderPDF(idWorkOrder, nim);
        } finally {
            setLoadingPreview(null);
        }
    };


    return (
        <ul className="list-unstyled mb-0">

            {/* RESULTADOS COMPLETOS */}
            {completeNotifications.length > 0 && (
                <>
                    <div className="notification-section-title">
                        <span>Resultados completos</span>
                        <span className="notification-count">
                            {completeNotifications.length}
                        </span>
                    </div>

                    {(showAllComplete
                        ? completeNotifications
                        : completeNotifications.slice(0, 2)
                    ).map(item => {

                        const exams = item.exams ?? [];
                        const isExpanded = expanded[item.id_work_order];
                        const examsToShow = isExpanded ? exams : exams.slice(0, 3);
                        const isNew = newNotifications.includes(item.id_work_order);

                        return (
                            <li
                                key={item.id_work_order}
                                className={`card-notifications-microsite ${removing[item.id_work_order] ? "removing" : ""
                                    }`}
                            >
                                <div className="d-flex">

                                    <div className="notification-icon-container">
                                           {isNew && (
                                                <span className="notification-new-dot" />
                                            )}
                                            <img
                                                src={notification}
                                                alt=""
                                                className="img-microsite-notification"
                                            />
                                    </div>
                                    

                                    <div className="flex-grow-1">

                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="tittle-notification">
                                                Resultados completos
                                            </div>

                                            <div className="sub-title-nim">
                                                NIM {item.nim}
                                            </div>
                                        </div>

                                        <div className="notification-description notification-description-row">

                                            <strong className="notification-patient">
                                                {item.patient_name}
                                            </strong>

                                            <div className="notification-result-actions">

                                                <button
                                                    className="notification-result-btn preview"
                                                    title="Previsualizar"
                                                    onClick={() => handlePreview(item.id_work_order, item.nim)}
                                                    disabled={loadingPreview === item.id_work_order}
                                                >
                                                    {
                                                        loadingPreview === item.id_work_order
                                                            ? <i className="pi pi-spin pi-spinner" />
                                                            : <i className="pi pi-eye" />
                                                    }
                                                </button>

                                                  <button
                                                    className="notification-result-btn download"
                                                    title="Descargar"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        printWorkOrder(item.nim);
                                                    }}
                                                    disabled={loadingDownloadPdf === item.nim}
                                                >
                                                    {
                                                        loadingDownloadPdf === item.nim
                                                            ? <i className="pi pi-spin pi-spinner" />
                                                            : <i className="pi pi-download" />
                                                    }
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="notification-actions">
                                        <i className="fa fa-times notification-close" onClick={() => {

                                                setRemoving(prev => ({
                                                    ...prev,
                                                    [item.id_work_order]: true
                                                }));

                                                setTimeout(() => {
                                                    markAsRead(item.id_work_order);
                                                }, 250);

                                            }}
                                        />

                                    </div>

                                </div>
                            </li>
                        );
                    })}

                    {completeNotifications.length > 2 && (
                        <div
                            className="notification-view-more"
                            onClick={() => setShowAllComplete(!showAllComplete)}
                        >
                            <i className={`fa ${showAllComplete ? "fa-angle-up" : "fa-angle-down"} mr-1`} />
                            {showAllComplete ? "Ver menos" : "Ver más"}
                        </div>
                    )}
                </>
            )}

            {/* RESULTADOS PARCIALES */}
            {partialNotifications.length > 0 && (
                <>
                    <div className="notification-section-title">
                        <span>Resultados parciales</span>
                        <span className="notification-count">
                            {partialNotifications.length}
                        </span>
                    </div>

                    {(showAllPartial
                        ? partialNotifications
                        : partialNotifications.slice(0, 2)
                    ).map(item => {

                        const exams = item.exams ?? [];
                        const isExpanded = expanded[item.id_work_order];
                        const examsToShow = isExpanded ? exams : exams.slice(0, 3);
                        const isNew = newNotifications.includes(item.id_work_order);


                        return (
                            <li
                                key={item.id_work_order}
                                className={`card-notifications-microsite ${removing[item.id_work_order] ? "removing" : ""
                                    }`}
                            >
                                <div className="d-flex">

                                     <div className="notification-icon-container">
                                        {isNew && (
                                            <span className="notification-new-dot" />
                                        )}
                                        <img
                                            src={parcial2}
                                            alt=""
                                            className="img-microsite-notification-parcial"
                                        />
                                    </div>

                                    <div className="flex-grow-1">

                                        <div className="d-flex justify-content-between align-items-center">

                                            <div className="tittle-notification">
                                                Resultados parciales
                                            </div>

                                            <div className="sub-title-nim">
                                                NIM {item.nim}
                                            </div>

                                        </div>

                                       <div className="notification-description notification-description-row">

                                        <strong className="notification-patient">
                                            {item.patient_name}
                                        </strong>

                                        <div className="notification-result-actions">

                                           <button
                                                className="notification-result-btn preview"
                                                title="Previsualizar"
                                                onClick={() => handlePreview(item.id_work_order, item.nim)}
                                                disabled={loadingPreview === item.id_work_order}
                                            >
                                                {
                                                    loadingPreview === item.id_work_order
                                                        ? <i className="pi pi-spin pi-spinner" />
                                                        : <i className="pi pi-eye" />
                                                }
                                            </button>

                                            {/* <button
                                                className="notification-result-btn download"
                                                title="Descargar"
                                                // onClick={() => handleDownload(item)}
                                            >
                                                <i className="pi pi-download" />
                                            </button> */}

                                        </div>

                                    </div>


                                        <div className="studies-notifications">

                                            {examsToShow.map(exam => (
                                                <span
                                                    key={exam}
                                                    className="span-studies-notifications"
                                                >
                                                    {exam}
                                                </span>
                                            ))}

                                            {exams.length > 4 && (
                                                <span
                                                    className="span-studies-notifications more"
                                                    onClick={() =>
                                                        setExpanded(prev => ({
                                                            ...prev,
                                                            [item.id_work_order]: !prev[item.id_work_order]
                                                        }))
                                                    }
                                                >
                                                    {isExpanded
                                                        ? "Ver menos"
                                                        : `+${exams.length - 4}`}
                                                </span>
                                            )}

                                        </div>

                                    </div>

                                    <div className="notification-actions">

                                        <i
                                            className="fa fa-times notification-close"
                                            onClick={() => {

                                                setRemoving(prev => ({
                                                    ...prev,
                                                    [item.id_work_order]: true
                                                }));

                                                setTimeout(() => {
                                                    markAsRead(item.id_work_order);
                                                }, 250);

                                            }}
                                        />

                                    </div>

                                </div>
                            </li>
                        );
                    })}

                    {partialNotifications.length > 2 && (
                        <div
                            className="notification-view-more"
                            onClick={() => setShowAllPartial(!showAllPartial)}
                        >
                            <i className={`fa ${showAllPartial ? "fa-angle-up" : "fa-angle-down"} mr-1`} />
                            {showAllPartial ? "Ver menos" : "Ver más"}
                        </div>
                    )}
                </>
            )}

        </ul>

    );
    
};